import { useEffect, useState } from "react";
import { getAvatarInitials } from "../../utils/avatarInitials";

interface AvatarProps {
  src?: string | null;
  name: string;
  imageAlt?: string;
  fallback?: string;
}

export function Avatar({ src, name, imageAlt = "", fallback }: AvatarProps) {
  const [failed, setFailed] = useState(!src);

  useEffect(() => {
    setFailed(!src);
  }, [src]);

  if (!src || failed) {
    return (
      <div className="avatar-placeholder">
        {fallback || getAvatarInitials(name)}
      </div>
    );
  }

  return <img src={src} alt={imageAlt} onError={() => setFailed(true)} />;
}
